/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GET_ORGANIZATION } from "../pages/Organization/graphql/organiztion-detail.query";
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { humanize } from "uno-js";
import { toast } from "react-hot-toast";
import {getErrorMessage} from "../utils/error.message";

const MODULE_NAME = "OrganizationService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class OrganizationService {
    private static instance: OrganizationService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): OrganizationService {
        if (!OrganizationService.instance) {
            OrganizationService.instance = new OrganizationService(props);
        }
        return OrganizationService.instance;
    }

    getMeta = (data: any) => {
        if (data) {
            let _output: any = [];

            for (const [key, value] of Object.entries(data)) {
                if (
                    key === "fullAddress" ||
                    key === "email" ||
                    key === "telephone" ||
                    key === "website" ||
                    key === "owner"
                ) {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value,
                    });
                } else if (key === "sameAs") {
                    _output.push({
                        key: humanize("website"),
                        value: value,
                    });
                }
            }
            return _output;
        }
    };

    async getOrganization() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient('graphql-gateway');
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ORGANIZATION,
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getOrganization: ", res);

                //return res?.data?.getMyOrganization;
                return {
                    organizationData: res?.data?.getMyOrganization,
                    img: res?.data?.getMyOrganization?.logo,
                    title: res?.data?.getMyOrganization?.name,
                    description: res?.data?.getMyOrganization?.description,
                    key: res?.data?.getMyOrganization?.fullAddress,
                    meta: this.getMeta(res?.data?.getMyOrganization),
                };
            }
        } catch (err) {
            getErrorMessage(err);
        }
    }
}
